/**
 * Calculate responsive column width based on base size and viewport
 * Uses CSS custom property --column-width-base for scaling
 */
export function getResponsiveColumnSize(baseSize: number): number {
    if (typeof window === 'undefined') return baseSize
    
    const width = window.innerWidth
    
    // Apply multipliers based on screen size
    if (width >= 1920) return Math.floor(baseSize * 1.4)
    if (width >= 1536) return Math.floor(baseSize * 1.2)
    if (width >= 1024) return Math.floor(baseSize * 1.1)
    return baseSize
}

/**
 * Column configuration with responsive breakpoints
 */
export interface ResponsiveColumnConfig {
    base: number      // Mobile/default width
    md?: number       // Tablet width (768px+)
    lg?: number       // Desktop width (1024px+)
    xl?: number       // Large desktop (1536px+)
    xxl?: number      // Ultra-wide (1920px+)
    minSize?: number  // Minimum width
    maxSize?: number  // Maximum width
}

export function applyResponsiveColumnSizes(config: ResponsiveColumnConfig): number {
    if (typeof window === 'undefined') return config.base
    
    const width = window.innerWidth
    
    if (config.xxl && width >= 1920) return config.xxl
    if (config.xl && width >= 1536) return config.xl
    if (config.lg && width >= 1024) return config.lg
    if (config.md && width >= 768) return config.md
    
    return config.base
}


